import { useEffect } from 'react'
import useFeatureFlagsContext from './useFeatureFlagsContext'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useFeatureFlags() {
  const {
    featureFlags, getFeatureFlags, requesting,
  } = useFeatureFlagsContext()

  const PDFv2 = featureFlags?.pdfV2
  const trafficVersion = featureFlags?.trafficVersion
  const overview = featureFlags?.overview

  useEffect(() => {
    if (featureFlags !== undefined || requesting.value) return
    getFeatureFlags()
  }, [featureFlags, getFeatureFlags, requesting])

  return {
    PDFv2,
    trafficVersion,
    overview,
  }
}

export default useFeatureFlags
